import React from 'react'
// used for making the prop types of this component
import PropTypes from 'prop-types'

// core components
import Button from '../CustomButtons/Button'
import defaultImage from '../../resource/image/defaultAvatar.png'
import { baseUrlPhotoCloud } from '../../services/apis/createAPIServices'

// import defaultImage from "assets/img/image_placeholder.jpg";
// import defaultAvatar from "assets/img/placeholder.jpg";

class ImageUpload extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            imagePreviewUrl: this.props.avatar
                ? this.props.avatar
                : defaultImage,
            urlUpload: null,
        }
    }
    fileInput = React.createRef()
    handleImageChange = e => {
        e.preventDefault()
        if (this.props.doUpload) {
            this.props.doUpload()
        }

        let reader = new FileReader()
        let file = e.target.files[0]

        reader.onloadend = e => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result,
            })
            let formData = new FormData()
            formData.append('files', file, file.name)

            fetch(baseUrlPhotoCloud, {
                method: 'POST',

                body: formData,
            })
                .then(respone => respone.json())
                .then(data => {
                    this.setState({ urlUpload: data.uploaded_files[0] })
                    console.log('testdata', data.uploaded_files[0])
                })
                .catch(error => console.log('error imgupload', error))
        }
        reader.readAsDataURL(file)
    }

    getUrlUpload = () => {
        const { urlUpload } = this.state
        return urlUpload
    }
    handleSubmit = e => {
        e.preventDefault()
        // this.state.file is the file/image uploaded
        // in this function you can save the image (this.state.file) on form submit
        // you have to call it yourself
    }
    handleClick = () => {
        this.fileInput.current.click()
    }
    handleRemove = () => {
        this.setState({
            file: null,
            imagePreviewUrl: this.props.avatar
                ? this.props.avatar
                : defaultImage,
        })
        this.fileInput.current.value = null
    }
    render() {
        var {
            avatar,
            addButtonProps,
            changeButtonProps,
            removeButtonProps,
        } = this.props
        return (
            <div className="fileinput text-center">
                <input
                    type="file"
                    style={{ visibility: 'hidden' }}
                    onChange={this.handleImageChange}
                    ref={this.fileInput}
                />
                <div className={'thumbnail' + (avatar ? ' img-circle' : '')}>
                    <img
                        style={{
                            width: 150,
                            height: 150,
                            borderRadius: 75,
                            objectFit: 'cover',
                        }}
                        src={this.state.imagePreviewUrl}
                        alt="..."
                    />
                </div>
                <div>
                    {avatar ? <br /> : null}
                    {this.state.file === null ? (
                        <Button
                            {...addButtonProps}
                            onClick={() => this.handleClick()}
                        >
                            Thay đổi hình ảnh
                        </Button>
                    ) : (
                        <Button
                            {...addButtonProps}
                            onClick={() => this.handleClick()}
                        >
                            Thay đổi hình ảnh
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}

ImageUpload.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object,
}

export default ImageUpload
